export default {
  styleOverrides: {
    root: {
      padding: '1rem'
    }
  }
};
